/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   marketing event constants
 */

export const ACCOUNT_CREATION = 'account_creation'
export const ALERT = 'alert'
export const ALERT_DELETE = 'alert_delete'
export const ALERT_MODIFY = 'alert_modify'
export const FAVORITE = 'favorite'
export const LEAD = 'lead'
export const LIST_SEARCH = 'list_search'
export const SELECT_OPEN_LEAD = 'select_open_lead'
export const VIEW = 'view'
export const STR_CLICK = 'str_click'
export const STR_INTEREST = 'str_interest'
export const NOTIFY_ME_UNIT = 'notifyMe_unit'
